import DecimalAmount from '../../../../support/DecimalAmount';

class ComplementoImpuestosLocalesInputTransformer {
  getName() {
    return 'ImpuestosLocales';
  }

  make(input) {
    const { Complemento = {} } = input;

    if (!Complemento || !Complemento.ImpuestosLocales) {
      return input;
    }

    const impuestosLocales = { ...Complemento.ImpuestosLocales };
    const { TotaldeRetenciones, TotaldeTraslados } = impuestosLocales;

    input = {
      ...input,
      Total: DecimalAmount.make(
        parseFloat(input.Total) - parseFloat(TotaldeRetenciones) + parseFloat(TotaldeTraslados)
      ).toFixed(2),
    };

    return input;
  }
}

export default ComplementoImpuestosLocalesInputTransformer;
